import React from 'react';
import Head from 'next/head';

interface SchemaInterface {
  data: any;
  name: string;
}

export const Schema: React.FC<SchemaInterface> = ({ data, name }) => {
  const schemaName = name + '-schema';
  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        id={schemaName}
        key={schemaName}
        type="application/ld+json"
      />
    </Head>
  );
};
